var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getData, getListWithParams, postData, putData, } from "@services/common/CommonService";
import { getUserName } from "@utils/auth";
/**
 * API endpoint for logging out a user.
 * @type {string}
 */
var LOGOUT_API = "/useractions/logout";
var FORGOT_PASSWORD_API = "/useractions/forgot-password";
var RESET_PASSWORD_API = "/useractions/reset-password";
/**
 * API endpoint for fetching user details.
 * @type {string}
 */
var USER_FETCH_API = "/user/find";
/**
 * API endpoint for updating user configuration details.
 * @type {string}
 */
var UPDATE_USER_CONF_API = "/user/updateUserConfig";
/**
 * API endpoint for updating user permission details.
 * @type {string}
 */
var UPDATE_USER_PERMISSION_UPDATE_API = "/userendpoints/update";
/**
 * API endpoint for all user endpoint details.
 * @type {string}
 */
var FIND_ALL_USER_PERMISSIONS = "/userendpoints/list";
/**
 * Logs out a user by sending a POST request to the backend.
 *
 * @param {{ username: string }} payload - An object containing the username to log out.
 * @returns {Promise<string | null>} A promise that resolves to a success message (string) on successful logout,
 * or `null` if the request fails.
 * @author niyas.shajahan
 * @since 2025-06-19
 */
export var LogoutApi = function (callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_1, apiError;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                console.log("Logging out user:", getUserName());
                return [4 /*yield*/, postData(LOGOUT_API, null)];
            case 1:
                response = _c.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_1 = _c.sent();
                // Using 'any' to access error.response.data
                console.error("API request failed during logout:", (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data);
                apiError = (_b = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _b === void 0 ? void 0 : _b.data;
                callbacks.onError(apiError);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Sends a Forgot Password request to the backend API.
 *
 * Calls the `FORGOT_PASSWORD_API` endpoint with the provided user credentials
 * to initiate a password reset email.
 *
 * @async
 * @function ForgotPasswordApi
 * @param {ForgotPasswordRequestDTO} forgotparams - Object containing `userId` and `email` of the user.
 * @returns {Promise<any | null>}
 *   - Returns the API response if successful.
 *   - Returns `null` if the request fails (e.g., network error or invalid credentials).
 * @author rajeev.k
 * @example
 * const request: ForgotPasswordRequestDTO = {
 *   userId: "john_doe",
 *   email: "john.doe@example.com"
 * };
 *
 * const response = await ForgotPasswordApi(request);
 * if (response) {
 *   console.log("Password reset email sent successfully");
 * } else {
 *   console.log("Failed to send password reset email");
 * }
 */
export var ForgotPasswordApi = function (forgotParams, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_2, apiError;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, postData(FORGOT_PASSWORD_API, forgotParams)];
            case 1:
                response = _c.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_2 = _c.sent();
                if (((_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.status) === 429) {
                    callbacks.onError({
                        message: "Too many password reset requests. Please wait a minute and try again.",
                    });
                    return [2 /*return*/];
                }
                apiError = (_b = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _b === void 0 ? void 0 : _b.data;
                callbacks.onError(apiError);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Sends a Reset Password request to the backend API.
 *
 * Calls the `RESET_PASSWORD_API` endpoint with the reset token and new password
 * to update the user's password.
 *
 * On a successful request, the response is passed to the `onSuccess` callback.
 * If the request fails, the API error is passed to the `onError` callback.
 *
 * @async
 * @function ResetPasswordApi
 * @param {ResetPasswordRequestDTO} resetParams - Object containing the reset token
 * and the user's new password.
 * @param {ServiceCallBack<string>} callbacks - Callback handlers for processing
 * successful and failed API responses.
 * @returns {Promise<void>} A promise that resolves after the API request and
 * corresponding callback have been processed.
 *
 * @example
 * const request: ResetPasswordRequestDTO = {
 *   token: "reset-token",
 *   newPassword: "newPassword"
 * };
 *
 * await ResetPasswordApi(request, {
 *   onSuccess: (response) => {
 *     console.log("Password reset successfully", response);
 *   },
 *   onError: (error) => {
 *     console.error("Password reset failed", error);
 *   }
 * });
 */
export var ResetPasswordApi = function (resetParams, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_3, apiError;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, postData(RESET_PASSWORD_API, resetParams)];
            case 1:
                response = _b.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_3 = _b.sent();
                apiError = (_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data;
                callbacks.onError(apiError);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetches user details from the API.
 * This function sends an API request to retrieve a user's information based on their ID. It handles
 * both successful and unsuccessful API responses. If the response body is a string, it parses it
 * into a JSON object.
 * @author rajeev.k
 * @template T The type of the user data expected in the response body.
 * @param {object} params The parameters for the API request.
 * @param {string | undefined} params.userId The ID of the user to fetch.
 * @returns {Promise<DatabaseSingleResponse<T> | null>} A Promise that resolves with a DatabaseSingleResponse object on success, or null on failure.
 */
export var fetchUserDetailsOnLogIn = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4, err;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getListWithParams(USER_FETCH_API, params)];
            case 1:
                response = _b.sent();
                return [2 /*return*/, response];
            case 2:
                error_4 = _b.sent();
                err = (_a = error_4 === null || error_4 === void 0 ? void 0 : error_4.response) === null || _a === void 0 ? void 0 : _a.data;
                console.error("getting user details failed status " +
                    (err === null || err === void 0 ? void 0 : err.status) +
                    " error " +
                    (err === null || err === void 0 ? void 0 : err.error));
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Updates user configuration settings (theme and language) via an API PUT request.
 * It sends the UserDTO object to the backend and returns the HTTP status code on a successful API call.
 *
 * @author rajeev.k
 * @param {UserDTO} userDetails The Data Transfer Object containing user ID and configuration updates (e.g., theme, language).
 * @returns {Promise<number>} A Promise that resolves with the HTTP status code (e.g., 200) on success, or null if the API request fails.
 */
export var updateUserConfigurations = function (userDetails, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_5;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, putData(UPDATE_USER_CONF_API, userDetails)];
            case 1:
                response = _b.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_5 = _b.sent();
                callbacks.onError((_a = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _a === void 0 ? void 0 : _a.data);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * this for uploading certificate in mandant settings
 * @param params the file, user ID and EORI number
 * @param url  the url to be connected
 * @returns the status of operation
 */
export var uploadDataFile = function (params, callbacks, url) { return __awaiter(void 0, void 0, void 0, function () {
    var endpoint, formData, response, error_6, apiError;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                endpoint = url;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                formData = new FormData();
                formData.append("file", params.file);
                if (params.userId) {
                    formData.append("userId", params.userId);
                }
                if (params.eoriNumber) {
                    formData.append("eoriNumber", params.eoriNumber);
                }
                return [4 /*yield*/, postData(endpoint, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })];
            case 2:
                response = _b.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 4];
            case 3:
                error_6 = _b.sent();
                console.error("Upload request failed:", error_6);
                apiError = (_a = error_6 === null || error_6 === void 0 ? void 0 : error_6.response) === null || _a === void 0 ? void 0 : _a.data;
                callbacks.onError(apiError);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Updates user endpoint permissions by sending a PUT request to the backend.
 *
 * @async
 * @function updatePermissions
 * @param {SaveEndpointsRequest} request - The request object containing userId and selected endpoint IDs.
 * @returns {Promise<DatabaseSingleResponse<number> | null>} A promise resolving to a `DatabaseSingleResponse<number>`
 * if successful, or `null` if the update fails.
 * @author rajeev.k
 * @example
 * const req: SaveEndpointsRequest = { userId: "admin", ids: ["1", "2", "3"] };
 * const result = await updatePermissions(req);
 * if (result) {
 *   console.log("Updated endpoints count:", result.responseBody);
 * }
 */
export var updatePermissions = function (request, callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_7;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, putData(UPDATE_USER_PERMISSION_UPDATE_API, request)];
            case 1:
                response = _b.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_7 = _b.sent();
                callbacks.onError((_a = error_7 === null || error_7 === void 0 ? void 0 : error_7.response) === null || _a === void 0 ? void 0 : _a.data);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Fetches all available user roles and permissions from the backend.
 *
 * @async
 * @function fetchAllUserRoles
 * @template T - The expected type of the response body (e.g., RoleEndpointDTO[]).
 * @returns {Promise<DatabaseSingleResponse<T> | null>} A promise resolving to a `DatabaseSingleResponse<T>`
 * if successful, or `null` if the fetch fails.
 * @author rajeev.k
 * @example
 * interface RoleEndpointDTO {
 *   id: number;
 *   role: string;
 *   permission: string;
 * }
 *
 * const roles = await fetchAllUserRoles<RoleEndpointDTO[]>();
 * if (roles) {
 *   console.log("Fetched roles:", roles.responseBody);
 * }
 */
export var fetchAllUserRoles = function (callbacks) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getData(FIND_ALL_USER_PERMISSIONS)];
            case 1:
                response = _b.sent();
                callbacks.onSuccess(response);
                return [3 /*break*/, 3];
            case 2:
                error_8 = _b.sent();
                callbacks.onError((_a = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _a === void 0 ? void 0 : _a.data);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
